import { jsx as _jsx } from "react/jsx-runtime";
import { StyledMenuDivider } from "segments/desktop/header/layouts/base-header/base-header-desktop/short-header-menu/menus/components/menu-divider/menu-divider.scss";
import classnames from "classnames";
const MenuDivider = ({ isHorizontal })=>/*#__PURE__*/ _jsx(StyledMenuDivider, {
        className: classnames("menu-divider", {
            horizontal: isHorizontal
        })
    });
export default MenuDivider;
